import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  height: calc(100% - 30px);
  margin: 15px;
  box-shadow: 0px 4px 6px ${ColorSF2.transparentShadow};
  @media (max-height: 530px) {
    height: calc(100% - 20px - 30px);
    margin: 10px 15px;
  }
`;

export const ContentsTitle = styled.div`
  height: 50px;
  padding: 15px;
  display: flex;
  align-items: center;
  font-weight: bold;
  background-color: ${ColorSF2.paleBlue};
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  @media (max-height: 530px) {
    height: 30px;
  }
`;
export const Contents = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
export const UpperContent = styled.div`
  margin-top: 10px;
`;
export const ContactActionsWrapper = styled.div`
  margin-top: 10px;
  padding: 10px;
  background: ${ColorSF2.white};
  display: ${props => (props.hidden && 'none') || 'flex'};
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 6px ${ColorSF2.transparentShadow};
`;
export const ButtonImage = styled.img`
  margin-right: 4px;
  margin-bottom: 1px;
  height: 14px;
  display: flex;
  align-items: center;
`;
export const UserSearchWrapper = styled.div`
  height: 40px;
  position: relative;
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding: 10px;
  background: ${ColorSF2.white};
  justify-content: space-between;
`;
export const Lists = styled.div`
  height: ${props => `calc(100% - ${props.upperHeight + 50}px)`};
`;
export const ContactsWrapper = styled.div`
  display: ${props => (props.hidden && 'none') || 'block'};
  height: calc(100% - 50px);
`;
export const NotAllowedMessage = styled(ContactsWrapper)`
  margin: 10px;
`;

export const OperatorContentContainer = styled.div`
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
`;
